import { render, staticRenderFns } from "./home-image.vue?vue&type=template&id=2fe73c10&scoped=true&"
import script from "./home-image.vue?vue&type=script&lang=js&"
export * from "./home-image.vue?vue&type=script&lang=js&"
import style0 from "./home-image.vue?vue&type=style&index=0&id=2fe73c10&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe73c10",
  null
  
)

export default component.exports